'use strict';

const workerUtils = require('./workerUtils');
const scriptsValidator = require('./scriptsValidator');
const scriptsHandler = require('./scriptHandler');
const bi = require('../bi');

function loadUserGeneratedApps({applications = [], workerId} = {}, appsStore) {
  const beforeLoad = Date.now();

  scriptsValidator.validate(applications, ['id', 'url']);

  workerUtils.importModules(applications, appsStore, scriptsHandler, true);

  workerUtils.reportPlatformRenderStepBI({
    workerId,
    timeSpent: Date.now() - beforeLoad,
    actionName: bi.ACTION_NAMES.USER_GENERATED_APPS_LOADED
  });
}

module.exports = {
  loadUserGeneratedApps
};
